import DataHandlerHelper from "../../helpers/DataHandler.helper";
import InitClientRegistrationLogic from "./ClientRegistration.logic";

const ClientRegistrationComponent: React.FC = () => {
    const { data, categories, prices, usernameRef, passwordRef, firstNameRef, lastNameRef, phoneRef, onSubmit, onChange, onPriceChange } = InitClientRegistrationLogic();
    return (
        <div className="page-container">
            <h1 className="text-align-center">Novi klijent</h1>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <button className="btn-primary" type="button" onClick={onSubmit}>Sačuvaj</button>

                <div>
                    <label htmlFor="firstName">Ime</label>
                    <input placeholder="Unesi ime..." id="firstName" type={"text"} ref={firstNameRef} onKeyDown={e => DataHandlerHelper.handleEnterKeyPress(e, () => lastNameRef.current.focus())} value={data.firstName} onChange={onChange} name="firstName" required></input>
                </div>
                <div>
                    <label htmlFor="lastName">Prezime</label>
                    <input placeholder="Unesi prezime..." id="lastName" type={"text"} ref={lastNameRef} onKeyDown={e => DataHandlerHelper.handleEnterKeyPress(e, () => usernameRef.current.focus())} value={data.lastName} onChange={onChange} name="lastName" required></input>
                </div>
                <div>
                    <label htmlFor="username">Korisničko ime</label>
                    <input placeholder="Unesi korisničko ime..." id="username" type={"text"} ref={usernameRef} onKeyDown={e => DataHandlerHelper.handleEnterKeyPress(e, () => passwordRef.current.focus())} value={data.username} onChange={onChange} name="username" required></input>
                </div>
                <div>
                    <label htmlFor="password">Lozinka</label>
                    <input placeholder="Unesi lozinku..." id="password" type={"text"} ref={passwordRef} onKeyDown={e => DataHandlerHelper.handleEnterKeyPress(e, () => phoneRef.current.focus())} value={data.password} onChange={onChange} name="password" required></input>
                </div>
                <div>
                    <label htmlFor="phone">Broj telefona</label>
                    <input placeholder="Unesi broj telefona" id="phone" type={"text"} ref={phoneRef} value={data.phone} onChange={onChange} name="phone" required></input>
                </div>
            </div>

            <div style={{ marginTop: '16px' }}>
                <h3>Cene po tipu treninga</h3>
                {categories.map((cat) => (
                    <div className="card" key={cat.id} style={{ marginTop: '12px' }}>
                        <h4>{cat.name}</h4>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {cat.trainingTypes?.map((tt: any) => (
                                <div key={tt.id}>
                                    <label htmlFor={`price-${tt.id}`}>{tt.name}</label>
                                    <input
                                        id={`price-${tt.id}`}
                                        type="number"
                                        inputMode="numeric"
                                        min={0}
                                        step={1}
                                        placeholder="0"
                                        value={prices[tt.id] ?? ""}
                                        onChange={(e) => onPriceChange(tt.id, e.target.value)}
                                    ></input>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            <div style={{ marginTop: '16px' }}>
                <button className="btn-primary" type="button" onClick={onSubmit}>Sačuvaj</button>
            </div>
        </div>
    );
}

export default ClientRegistrationComponent;
